<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="field">
    <label for="newPassword">Nova senha</label>
    <input
      pInputText
      id="newPassword"
      type="password"
      formControlName="newPassword"
      placeholder="Mínimo 8 caracteres"
      class="w-full"
    />
    <small
      class="p-error"
      *ngIf="
        form.get('newPassword')?.touched &&
        form.get('newPassword')?.hasError('required')
      "
    >
      Senha é obrigatória.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('newPassword')?.touched &&
        form.get('newPassword')?.hasError('minlength')
      "
    >
      Mínimo 8 caracteres.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('newPassword')?.touched &&
        form.get('newPassword')?.hasError('uppercase')
      "
    >
      Deve conter pelo menos uma letra maiúscula.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('newPassword')?.touched &&
        form.get('newPassword')?.hasError('number')
      "
    >
      Deve conter pelo menos um número.
    </small>
    <small
      class="p-error"
      *ngIf="
        form.get('newPassword')?.touched &&
        form.get('newPassword')?.hasError('specialChar')
      "
    >
      Deve conter pelo menos um caractere especial.
    </small>
  </div>

  <div class="field">
    <label for="newPasswordConfirmation">Confirmação de nova senha</label>
    <input
      pInputText
      id="newPasswordConfirmation"
      type="password"
      formControlName="newPasswordConfirmation"
      placeholder="Repita a nova senha"
      class="w-full"
    />
    <small
      class="p-error"
      *ngIf="
        form.get('newPasswordConfirmation')?.touched &&
        form.hasError('mismatch')
      "
    >
      Senha e confirmação não conferem.
    </small>
  </div>

  <div class="flex justify-content-end gap-2 mt-4">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="ref.close(false)"
    ></button>
    <button
      pButton
      type="submit"
      label="Alterar senha"
      [disabled]="form.invalid"
    ></button>
  </div>
</form>
